module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEoSURBVEhL3ZTdbcJAEIT9BtQBfZAqcBmJBE9IKJRKCS4A2Zk5Zs365451JKQon3Q63+7sDNiyq/9N27bfXDpmgebcdV2DvVbpNTTGUKIUMtLdQyE2pIG7rmdD0Lqyb2jmoPYUGjlhrWUhR8mo2+tyEgIatYZgaGCuMusMuWHtdDZd/69w7ENQv6j8xA3N3kfUVtqTzuA5CQCODLnqOETNbAAZmxs+pAi02ZCcueND0jIQWsgN25q1gPn8bckBwy+swQMtsMzcEzXnj8H6TENRFphvsHg74w87am5A71/GcshScyMUEjWHLr10Hh9guglq5jDzLRY/G+NPSdmcSDBHPwSjEws0lHHMnEg0ZjLEGhsKiZkTCT3ZIfYeksRr899A47eZ/xGq6gc+0WQ/UZH/RAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-design/light/24.png
// module id = 1986
// module chunks = 2